'use client';

import {useRouter} from 'next/navigation';
import {useTranslation} from 'react-i18next';
import type {DetailPageAnalytics} from '../../analytics';
import type {PhaseCardView} from '../../model';
import {phaseStatusKey} from '../../model';
import {CardStatusChip, ListingCard, LOCATION_ICON} from '../listing';

export interface PhaseCardProps {
  phase: PhaseCardView;
  href: string;
  analytics: DetailPageAnalytics;
  onRegisterInterest: (phase: PhaseCardView) => void;
}

export function PhaseCard({phase, href, analytics, onRegisterInterest}: PhaseCardProps) {
  const {t} = useTranslation();
  const router = useRouter();
  const tracked = {id: phase.uuid, name: phase.title};
  const statusKeys = phaseStatusKey(phase.status);

  statusKeys?.sort((a, b) => a.localeCompare(b));
  const tags = statusKeys?.map(key => <CardStatusChip key={key} statusKey={key} label={t(key)} />);

  const badges = [{label: phase.projectLabel}];

  return (
    <ListingCard
      title={phase.title}
      image={phase.image.src}
      href={href}
      tags={tags}
      badges={badges}
      primaryMeta={phase.location ? {icon: LOCATION_ICON, label: phase.location} : undefined}
      onClick={() => {
        analytics.carouselCard(tracked, 'phases');
      }}
      hoverActions={[
        {
          label: t('register_interest'),
          onClick: () => {
            onRegisterInterest(phase);
          },
        },
        {
          label: t('view_details'),
          onClick: () => {
            analytics.carouselCard(tracked, 'phases');
            router.push(href);
          },
        },
      ]}
    />
  );
}

PhaseCard.displayName = 'PhaseCard';
